/* tslint:disable */
/* eslint-disable */
/**
 * My REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: jason.tai@octopus-tech.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CategoryParentConflictPayload
 */
export interface CategoryParentConflictPayload {
    /**
     * 
     * @type {string}
     * @memberof CategoryParentConflictPayload
     */
    mongoId?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryParentConflictPayload
     */
    parentMongoId?: string;
}

export function CategoryParentConflictPayloadFromJSON(json: any): CategoryParentConflictPayload {
    return CategoryParentConflictPayloadFromJSONTyped(json, false);
}

export function CategoryParentConflictPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoryParentConflictPayload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mongoId': !exists(json, 'mongoId') ? undefined : json['mongoId'],
        'parentMongoId': !exists(json, 'parentMongoId') ? undefined : json['parentMongoId'],
    };
}

export function CategoryParentConflictPayloadToJSON(value?: CategoryParentConflictPayload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mongoId': value.mongoId,
        'parentMongoId': value.parentMongoId,
    };
}

